import $ from "jquery";

const loader = {
  CSS_CLASS: "loader",
  DEFAULT_TEXT: "Loading...",

  /**
   * Hide loader
   */
  hide() {
    this.$el.hide();
  },

  /**
   * Add loading indicator to DOM
   * @param {string=} text
   */
  add(text) {
    this.$el = $("<div>")
      .addClass(this.CSS_CLASS)
      .text(text || this.DEFAULT_TEXT);
    this.$el.prependTo($("body")).fadeIn("slow");
  },

  /**
   * Show loading indicator
   * @param  {string=} text
   */
  show(text) {
    this.$el = $(`.${this.CSS_CLASS}`);
    if (this.$el.length) {
      this.$el.show();
    } else {
      this.add(text);
    }
  },
};

export default loader;
